<template>
  <div v-if="visible" id="help" class="notification has-background-grey-darker">
    <b>{{ $t('help') }}</b>
    <ul>
      <li>Click on parcel for detailed info</li>
      <li>Animate status changes with the time-bar</li>
    </ul>
  </div>
</template>

<script>


export default {
  name: 'HelpComponent',
  data () {
    return {
      visible: true
    }
  },
  computed: {

  },
  methods: {

  }
}

</script>

<style lang="stylus" scoped>

#help
  margin: 0px 6px 26px 6px
  padding: 0
  ul
    list-style-type: disc
    padding-left: 20px

</style>
